import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=43b3ca53&scoped=true&lang=pug&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=43b3ca53&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3ca53",
  null
  
)

component.options.__file = "MessageList.vue"
export default component.exports